import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-EBVWS54JXW";
const COOKIE_CONSENT_KEY = "zillhub_cookie_consent";

export const initGA = () => {
  // Check if user has consented to cookies
  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  
  if (consent === "declined") {
    return;
  }
  
  if (MEASUREMENT_ID) {
    ReactGA.initialize(MEASUREMENT_ID, {
      gaOptions: {
        anonymizeIp: true, // Privacy protection
        storage: consent === "accepted" ? "enabled" : "none",
      },
    });
  } else {
    console.warn("Google Analytics Measurement ID not found");
  }
};

export const logPageView = (path: string, title?: string) => {
  if (MEASUREMENT_ID) {
    ReactGA.send({ hitType: "pageview", page: path, title });
  }
};

export const logEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
) => {
  if (MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

// Custom events for your app
export const trackLessonCompleted = (lessonId: string, domain: string) => {
  logEvent("Learning", "Lesson Completed", `${domain}/${lessonId}`);
};

export const trackQuizCompleted = (score: number, lessonId: string) => {
  logEvent("Learning", "Quiz Completed", lessonId, score);
};

export const trackResilienceCheckIn = (score: number) => {
  logEvent("Engagement", "Resilience Check-In", `Score: ${score}`, score);
};

export const trackJournalEntry = () => {
  logEvent("Engagement", "Journal Entry Created");
};

export const trackDailyChallengeCompleted = (accuracy: number) => {
  logEvent("Engagement", "Daily Challenge Completed", undefined, Math.round(accuracy * 100));
};

export const trackZillAiMessage = () => {
  logEvent("Engagement", "ZillAi Message Sent");
};

export const trackSignUp = (method: string) => {
  logEvent("User", "Sign Up", method);
};

export const trackLogin = (method: string) => {
  logEvent("User", "Login", method);
};
